import { useEffect, useRef } from 'react';

export default function Hero() {
  const ref = useRef(null);
  useEffect(() => {
    const els = ref.current?.querySelectorAll('[data-r]');
    if (!els) return;
    els.forEach((el, i) => {
      el.style.opacity = '0';
      setTimeout(() => {
        el.style.transition = 'opacity 0.6s ease';
        el.style.opacity = '1';
      }, 80 + i * 100);
    });
  }, []);

  return (
    <div className="">
      <div className="max-w-7xl mx-auto px-6 pt-10 pb-0">
        <div className="flex items-center gap-4 mb-2">
          <div className="bg-red text-paper font-sans text-xs font-black tracking-widest px-3 py-1.5 uppercase">
            HOT
          </div>
          <div className="border-t border-rule-2 flex-1" />
          <span className="font-mono text-xs text-dim">HOT · NEWS</span>
        </div>
        <div data-r className="grid grid-cols-1 md:grid-cols-12 gap-0 pt-6 pb-8">
          <div className="md:col-span-5 md:pr-6 md:border-r md:border-rule-2">
            <p className="font-sans text-xs text-dim mb-3">기자: caratings 편집국 · 데이터 분석팀</p>
            <p className="font-serif text-base leading-relaxed text-ink mb-4">
              caratings는 2018년 설립 이후 500개 이상의 브랜드와 함께 디지털 마케팅의 새로운 기준을 써왔다.
              단순한 광고 집행이 아닌, 실시간 데이터 분석과 창의적 전략으로 브랜드 성장을 이끄는 것이 이 에이전시의 핵심이다.
            </p>
            <p className="font-serif text-base leading-relaxed text-ink mb-6">
              6개월 평균 ROI 340% 달성, 고객 만족도 98%. 이 수치들은 단순한 홍보 문구가 아니라
              수백 개의 캠페인에서 검증된 실제 성과다.
            </p>
          </div>

          <div className="md:col-span-4 md:px-6 md:border-r md:border-rule-2 mt-8 md:mt-0">
            <div className="border-t-4 border-red pt-4 mb-6">
              <blockquote className="font-headline text-xl font-bold italic text-ink leading-snug mb-3">
                "광고비를 쓰지 않아도 되는 마케팅 전략, 그게 진짜 마케팅입니다."
              </blockquote>
              <p className="font-sans text-xs text-dim">— caratings 대표 인터뷰 중</p>
            </div>
            <div className="w-full border-t border-rule-2 mb-6" />
            <h3 className="font-headline font-bold text-lg text-ink mb-2">주요 서비스 영역</h3>
            <ul className="space-y-2">
              {['브랜드 전략 · Identity', 'SNS 마케팅 · Growth', '퍼포먼스 광고 · ROAS', '콘텐츠 제작 · Creative', 'SEO / 검색 · Traffic'].map(s => (
                <li key={s} className="font-serif text-sm text-ink border-b border-rule-2 pb-2 last:border-0">
                  {s}
                </li>
              ))}
            </ul>
          </div>

          {/* Col 3 — sidebar stats */}
          <div className="md:col-span-3 md:pl-6 mt-8 md:mt-0">
            <div className="text-black p-5 mb-4">
              <p className="text-xs mb-3">핵심 수치</p>
              {[
                { n: '500+', l: '브랜드 파트너' },
                { n: '98%', l: '고객 만족도' },
                { n: '3.4×', l: '평균 ROI' },
                { n: '7년', l: '업력' },
              ].map(s => (
                <div key={s.l} className=" py-3 last:border-0 last:pb-0">
                  <div className="font-headline font-black text-2xl text-red">{s.n}</div>
                  <div className="text-xs">{s.l}</div>
                </div>
              ))}
            </div>
            <div className="p-4">
              <p className="font-sans text-xs font-bold tracking-[0.2em] uppercase text-red mb-2">지금 바로</p>
              <p className="font-headline font-bold text-base text-ink mb-3">무료 브랜드 진단을 받아보세요</p>
              <a href="#contact" className="inline-flex items-center gap-2 bg-red text-paper font-sans font-semibold text-sm px-6 py-3 transition-all duration-200 hover:opacity-90 w-full justify-center text-xs" style={{ display: 'flex' }}>
                신청하기 →
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
